module.exports = __webpack_public_path__ + "img/twitter.420afc01.svg";